import React from 'react';
import PropTypes from 'prop-types';

import Fab from '@material-ui/core/Fab/Fab';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import PrintIcon from '@material-ui/icons/Print';
import JobIcon from '@material-ui/icons/Transform';
import FileUpload from '@material-ui/icons/CloudUpload'
import Grid from '../../Common/Grid';
import Cell from '../../Common/Grid/Cell';
import IdentityLabel from '../../Common/IdentityLabel';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import { TableFilterRow } from '@devexpress/dx-react-grid-material-ui';
import getNoDataCellComponent from '../../Common/NoDataCellComponent';

import styles from './styles';
import { GENERATE_LABELS_DIALOG, TASK_UPLOAD_DIALOG } from '../../../redux/constants/dialogs';

const COLUMNS = [
  { name: 'reference', title: 'Reference' },
  { name: 'customer', title: 'Customer' },
  { name: 'description', title: 'Description' },
  { name: 'primaryContact', title: 'Primary Contact' },
  { name: 'start', title: 'Start' },
  { name: 'tasks', title: 'Tasks' },
  { name: 'created', title: 'Created', visible: false },
  { name: 'updated', title: 'Updated', visible: false },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'reference', width: 100 },
  { columnName: 'tasks', width: 100 },
  { columnName: 'start', width: 100 },
  { columnName: 'created', width: 100 },
  { columnName: 'updated', width: 100 },
  { columnName: 'action', width: 120 },
];

const getCellComponent = (showDialog, onUpload) => ({ row, column, value }) => {
  switch (column.name) {
    case 'primaryContact':
      return value ? <IdentityLabel identity={value} showDialog={showDialog}/> : null;
    case 'customer':
      return value ? value.name : null;
    case 'start':
      return moment(value).format('ll');
    case 'tasks':
      return value ? value.count : 0;
    // case 'action':
    case 'action':
      return (<div>
        <Tooltip title="Print Labels">
          <IconButton onClick={() => showDialog(GENERATE_LABELS_DIALOG, { job: row })}><PrintIcon/></IconButton>
        </Tooltip>
        <Tooltip title="Upload Tasks">
          <IconButton onClick={() => showDialog(TASK_UPLOAD_DIALOG, { job: row })}><FileUpload color="inherit"/></IconButton>
        </Tooltip>
      </div>);
    default:
      return value;
  }

};

const getFilterCellComponent = ({ column, children, ...other }) => {
  switch (column.name) {
    case 'customer':
      return (<TableFilterRow.Cell {...other} >{children}</TableFilterRow.Cell>);
    default:
      return <Cell/>;
  }
};

/*
{editable ? <Fab
          style={styles.addItem}
          onClick={this.handleCreateJobRequest}
          color="secondary"
        >
          <ContentAdd/>
        </Fab> : null}

        {editable ? <Fab
          style={styles.removeItem}
          onClick={this.handleMultiRemove}
          color="secondary"
        >
          <DeleteIcon style={styles.icon}/>
        </Fab> : null}
 */

const JobsGrid = ({ data, fetch, onAdd, onEdit, onRemove, showDialog }) => {
  const buttons = onAdd ? [<Tooltip key="create" title="Add Job">
    <Fab
      color="secondary"
      aria-label="add"
      style={styles.add}
      onClick={onAdd}
      id="addJob"
    >
      <AddIcon/>
    </Fab>
  </Tooltip>] : [];

  return <Grid
    buttons={buttons}
    columns={COLUMNS}
    columnExtensions={COLUMN_EXTENSIONS}
    cellComponent={getCellComponent(showDialog)}
    filterCellComponent={getFilterCellComponent}
    fetch={fetch}
    data={data}
    onEdit={onEdit}
    onRemove={onRemove}
    noDataCellComponent={getNoDataCellComponent(<JobIcon style={styles.noData}/>, 'jobs')}
  />;
};

JobsGrid.propTypes = {
  showDialog: PropTypes.func.isRequired,
  data: PropTypes.object,
  fetch: PropTypes.func,
};

export default JobsGrid;



// WEBPACK FOOTER //
// ./src/components/Jobs/JobsGrid/index.js